/**
 * SessionLeadersSubNav — MED-1009 / E4.0e AC1
 *
 * Sub-navigation for the Session Leaders tab, splitting it into a Schedule
 * subpage (the existing group × session grid) and a Participants subpage (the
 * new read-only rationale reference). Reuses the shared `ButtonToggle`
 * segmented-control pattern already used by the coaches page sub-nav
 * (CoachesSubNav) — no net-new design. Schedule is the default.
 */
import { Calendar, Users } from 'react-feather';
import { ButtonToggle } from '../../../../components/common';

export type SessionLeadersSubTab = 'schedule' | 'participants';

interface SessionLeadersSubNavProps {
  activeSubTab: SessionLeadersSubTab;
  onSubTabChange: (tab: SessionLeadersSubTab) => void;
}

export function SessionLeadersSubNav({
  activeSubTab,
  onSubTabChange,
}: SessionLeadersSubNavProps) {
  return (
    <ButtonToggle
      options={[
        { value: 'schedule', label: 'Schedule', icon: Calendar },
        { value: 'participants', label: 'Participants', icon: Users },
      ]}
      value={activeSubTab}
      onChange={onSubTabChange}
    />
  );
}

export default SessionLeadersSubNav;
